/*jshint esversion: 6 */

import React from "react";
import axios from "axios";

class CaAccountFormContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitPressed: false,
      validationMutation: []
    };
    this.onItemChange = this.onItemChange.bind(this);
    this.onCheckboxChange = this.onCheckboxChange.bind(this);
    this.onSelectChange = this.onSelectChange.bind(this);
  }

  onSubmit(e, data) {
    e.preventDefault();

    const validationMutation = this.updateValidation(data);

    var allValid = true;
    validationMutation.map(a => {
      allValid = allValid && a.valid;
    });

    this.setState({
      submitPressed: true,
      validationMutation: validationMutation
    });

    if (allValid) {
      // Send to GC-Api
      let email = data.reduce(
        (acc, item) => (item.type == "email" ? acc + item.value : acc),
        ""
      );
      let country = data.reduce(
        (acc, item) => (item.type == "select" ? acc + item.value : acc),
        ""
      );

      var formData = new FormData();
      formData.append("email", email);
      formData.append("country", country);
      formData.append("action", "abba_signup");

      axios({
        method: "post",
        url: ajax_object.ajax_url,
        data: formData
      })
        .then(function(response) {
          console.log(response);
        })
        .catch(function(error) {
          console.log(error);
        });
    }

    if (allValid) {
      const { onSubmit } = this.props;
      onSubmit(data);
    }
  }

  updateValues(data) {
    const valueMutation = data.map(item => {
      item.value = item.type == "checkbox" ? !item.value : item.ref.value;
      return item;
    });
    return valueMutation;
  }

  updateValidation(data) {
    const validationMutation = data.map(item => {
      item.validateItem = true;
      item.valid = this.validate(item);
      return item;
    });
    return validationMutation;
  }
  validate(item) {
    switch (item.validateAs) {
      case "email":
        return this.validateEmail(item);

      case "password_repeat":
        return this.validatePassword(item);

      case "password":
      case "text":
        return this.validateText(item);

      case "select":
        return true;
      case "checkbox":
        return item.value == true;
    }
  }
  onItemChange(e, data) {
    const ids = data.map(item => item.id);
    const obj = data[ids.indexOf(e.target.id)];
    if (obj.type == "checkbox") {
      obj.value = !obj.value;
    } else {
      obj.value = e.target.value;
    }

    if (!this.state.submitPressed) {
      this.setState({
        validationMutation: data
      });
      return;
    }
    this.setState({
      validationMutation: this.updateValidation(data)
    });
  }

  /*
    onFieldChange(e,data) {
        if ( !this.state.submitPressed ) return;
        this.setState({
            validationMutation:this.updateValidation(data)
        });
    }
    */
  onCheckboxChange(e, data) {
    const items = data.map(item => {
      if (item.type !== "checkbox") return item;
      item.value = !item.value;
      return item;
    });

    if (!this.state.submitPressed) {
      this.setState({
        validationMutation: items
      });
      return;
    }
    this.setState({
      validationMutation: this.updateValidation(items)
    });
  }

  onSelectChange(e, data) {
    const items = data.map(item => {
      if (item.type !== "select") return item;
      item.value = item.ref.value;
      return item;
    });

    if (!this.state.submitPressed) {
      this.setState({
        validationMutation: items
      });
      return;
    }
    this.setState({
      validationMutation: this.updateValidation(items)
    });
  }

  validateText(item) {
    return item.ref.value.replace(/\s\d/g, "").length > 2;
  }
  validatePassword(item) {
    const item2 = document.querySelector("#" + item.validateToId);
    return (
      !item2.classList.contains("invalid") && item.ref.value == item2.value
    );
  }
  validateEmail(item) {
    const regEx = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return regEx.test(item.ref.value);
  }

  render() {
    const {
      FormViewContainer,
      onClose,
      iconsBasePath,
      onNavigate,
      errorMessage,
      successMessage
    } = this.props;
    const { validationMutation } = this.state;

    return (
      <FormViewContainer
        onClose={onClose}
        iconsBasePath={iconsBasePath}
        onSubmit={(e, data) => this.onSubmit(e, data)}
        onFieldChange={(e, data) => this.onItemChange(e, data)}
        onCheckboxChange={(e, data) => this.onItemChange(e, data)}
        onSelectChange={(e, data) => this.onItemChange(e, data)}
        onNavigate={onNavigate}
        errorMessage={errorMessage}
        successMessage={successMessage}
        validationMutation={validationMutation}
      />
    );
  }
}

export default CaAccountFormContainer;
